import { render } from "./ClientsSection.vue?vue&type=template&id=68700d3a&scoped=true"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"

import "./ClientsSection.vue?vue&type=style&index=0&id=68700d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68700d3a"]])

export default __exports__